export default "__VITE_ASSET__mearWFFD__"